var app = angular.module("leonardo");

var ReportsActions = function($scope, $filter, $state, $http, ngDialog, FilterService, PropertyGroupService, AuthDataService,
                              ScheduleService, NotificationService, ReportService, ReportFilterService, ConfigThemeService, $q,
                              AccountUserService, PermissionService, DynamicFormRestService) {

  $scope.report = ReportService.getQuickReport();
  $scope.superuser = $state.current.superuser || false;
  $scope.title_quick = ReportService.getTitleQuick();
  
  if ($scope.title_quick === '') {
    $scope.title_quick = $state.current.reportTitle;
  }

  $scope.hideExport = function () {
    return $scope.report_type && [ReportService.TYPE_UNIT, ReportService.TYPE_WORKFLOW].includes($scope.report_type.toString()) &&
      FilterService.hasFilter('unit_report_type') && (FilterService.getFilter('unit_report_type') === ReportService.REPORT_TYPE_APPROVALS);
  };

  $scope.reportOwner = function() {
    if (!$scope.report) {
      return false;
    }
    else if (!$scope.report.account) {
      return AuthDataService.isAdmin() || ($scope.report.client_instance && AuthDataService.isWhiteLabelAdmin());
    }
    else if ($scope.report.account_user) {
      return $scope.report.account_user.id === AccountUserService.currentAccountUser.id;
    }
  };

  $scope.accountOwner = function() {
    if (!$scope.report) {
      return false;
    }

    else if (!$scope.report.account) {
      return AuthDataService.isAdmin() || ($scope.report.client_instance && AuthDataService.isWhiteLabelAdmin());
    }
    else if(PermissionService.isAccountOwner()) {
      return true;
    }
    else if ($scope.report.account_user) {
      return $scope.report.account_user.id === AccountUserService.currentAccountUser.id;
    }
  
  };

  $scope.showExportCSV = function() {
    return ($scope.report_type === ReportService.TYPE_ACTIVITY) && ($scope.report && $scope.report.download_csv);
  };

  $scope.saveReport = function (filters) {
    $scope.report.patch({filters: filters, only_superuser: $scope.superuser}).then(function (result) {
      NotificationService.notify('success', $filter('translate')('The report has been saved successfully'));
      $scope.report = result;
      ReportService.setQuickReport($scope.report);
    });
  };

  $scope.manageExtraFields = function (filters) {
    if(!isNull(filters['extra_fields']) && $scope.report_type.toString() !== ReportService.TYPE_DYNAMIC_FORM) {
      let default_fields = [];
      if(!isNull(filters['fields_active'])) {
        default_fields = filters['fields_active'].split(',');
      } else {
        switch ($scope.report_type.toString()) {
          case ReportService.TYPE_ACTION_ITEM:
            default_fields = ReportService.defaultActionItemsFields;
            break;
          case ReportService.TYPE_PROPERTY_AMENITIES:
            default_fields = ReportService.defaultFieldsReportPropertyAmenities;
            break;
          case ReportService.TYPE_PROPERTY:
            default_fields = ReportService.defaultFieldsReportProperty;
            break;
        }
      }
      const concatenated_fields = filters['extra_fields'].split(',').concat(default_fields);
      filters['fields_active'] = concatenated_fields.toString();
    }
    return filters;
  };

  $scope.doSave = function () {
    var schedule = null;
    var report_type = $scope.report_type;
    var filters = $scope.getValidFilters();
    if ((AuthDataService.isAdmin() || AuthDataService.isWhiteLabelAdmin()) && !$scope.superuser) {
      angular.forEach(filters, function (filter, key) {
        if (['account', 'property', 'portfolio', 'group'].includes(key)) {
          delete (filters[key]);
        }
      });
    }
    else if ((AuthDataService.isAdmin() || AuthDataService.isWhiteLabelAdmin()) && AccountUserService.currentAccountUsers.length < 2) {
      delete (filters['account']);
    }
    // updated the filters to send extra fields in fields_active
    filters = $scope.manageExtraFields(filters);
    if ($scope.report) {
      schedule = $scope.report.schedule;
      if ($scope.reportOwner()) {
        $scope.saveReport(filters);
      }
      else {
        ngDialog.openConfirm({
          template: 'views/templates/dialog/report/add-report.html',
          controller: 'ReportDialog',
          data: {
            report_type: report_type,
            filters: filters,
            schedule: schedule,
            only_superuser: $scope.superuser,
            report_info: $scope.report,
          }
        }).then(function (result) {
          $scope.report = result;
          ReportService.setQuickReport($scope.report);
        });
      }
    }
    else {
      ngDialog.openConfirm({
        template: 'views/templates/dialog/report/add-report.html',
        controller: 'ReportDialog',
        data: {
          report_type: report_type,
          filters: filters,
          schedule: schedule,
          only_superuser: $scope.superuser
        }
      }).then(function (result) {
        $scope.report = result;
        ReportService.setQuickReport($scope.report);
      });
    }
  };

  $scope.getGroupRecord = function(Ids, isExport){
    PropertyGroupService.getGroups(Ids).then(function (data) {
      if (data) {
        ngDialog.open({
          template: 'views/templates/dialog/report/group-error.html'
        });
      }
      else {
        if(isExport){
          $scope.doExport();
        }
        else{
          $scope.doSave();
        }
      }
    });
  }

  $scope.showSaveReport = function () {
    if (FilterService.hasFilter('group_by') && FilterService.getFilter('group_by') === 'group') {
      if (FilterService.hasFilter('group_reports')) {
        var groups_Ids = FilterService.getFilter('group_reports').toString().split(',');
        if (groups_Ids.length > 1) {
          $scope.getGroupRecord(groups_Ids, false);
        }
        else {
          $scope.doSave();
        }
      }
      else {
        $scope.getGroupRecord(null, false);
      }
    }
    else {
      $scope.doSave();
    }
  };

  $scope.doExport = function() {
    var defer = $q.defer();
    var title = ($scope.report && $scope.report.name) ? $scope.report.name : null;
    var filters = $scope.getValidFilters();
    if ($scope.group_by === 'ungroup') {
      delete (filters['group_by']);
    }
    var data_export = {
      report_type: $scope.report_type,
      report_title: title,
      filters:filters
    };
    if ($scope.report_type === ReportService.TYPE_ACTIVITY) {
      data_export.is_user_report = true;
    }
    if($scope.report_type === ReportService.TYPE_TEMPLATE && !filters['group_by'] && data_export['filters']){
      data_export['filters']['group_by'] = 'ungroup';
    }

    if ($scope.report_type === ReportService.TYPE_DYNAMIC_FORM) {
      data_export.dynamic_form = filters['dynamic_form'];
      if (!title && filters['dynamic_form']){
        DynamicFormRestService.get(filters['dynamic_form']).then(function(result) {
          data_export.title = result.name + ' Report';
          defer.resolve();
        });
      }
      else {
        defer.resolve();
      }
    }
    else {
      defer.resolve();
    }
    $q.when(defer.promise).then(function() {
      ReportFilterService.showExportDialog(data_export);
    });
  };

  $scope.showExportDialog = function () {
    if (FilterService.hasFilter('group_by') && FilterService.getFilter('group_by') === 'group') {
      if (FilterService.hasFilter('group_reports')) {
        var groups_Ids = FilterService.getFilter('group_reports').toString().split(',');
        if (groups_Ids.length > 1) {
          $scope.getGroupRecord(groups_Ids, true);
        }
        else {
          $scope.doExport();
        }
      }
      else {
        $scope.getGroupRecord(null, true);
      }
    }
    else {
      $scope.doExport();
    }
  };

  $scope.showScheduleAddDialog = function () {
    if ($scope.report) {
      ngDialog.openConfirm({
        template: 'views/templates/dialog/report/add-schedule.html',
        className: 'ngdialog-theme-default ngdialog-schedules',
        controller: 'ScheduleAddDialog',
        data: {
          report: $scope.report
        }
      }).then(function (result) {
        $scope.report = result;
      });
    }
    else {
      ngDialog.open({
        template: 'views/templates/dialog/report/warning-schedule.html'
      });
    }
  };

  $scope.exportActivityCsv = function() {
    $scope.loading = ngDialog.open({
      template: 'views/templates/dialog/report/loading.html',
      className: 'ngdialog-theme-default dialog-loading',
      showClose: false
    });
    var url = ConfigThemeService.generateURL('/api/2.0/account-users-activity/report/export-csv/');
    var filters = $scope.getValidFilters();
    if (filters['group_by'] === 'ungroup') {
      delete (filters['group_by']);
    }
    angular.forEach(filters, function (value, key) {
      if (angular.isString(value)) {
        filters[key] = encodeURIComponent(value);
      }
    });
    var url_filters = $scope.generateUrl(url,filters);
    var promise = $http.get(url_filters);
    promise.then(function(data) {
      $scope.loading.close();
      var a = window.document.createElement('a');
      a.href = window.URL.createObjectURL(new Blob([data.data], {type: 'text/csv'}));
      a.download = 'report.csv';
      a.click();
    },function(){
      $scope.loading.close();
    });
  };

  $scope.generateUrl = function(url, filters) {
    filters['report_title'] = $scope.title_quick;
    var query = '?';
    angular.forEach(filters, function(value, key) {
      if (value !== null && value !== undefined && value !== '' && value !== 0) {
        if (angular.isArray(value)) {
          query += key + '=' + value.join(",") + '&';
        }
        else {
          query += key + '=' + value + '&';
        }
      }
    });
    query = query.slice(0, -1);
    url += query;
    return url;
  };

  $scope.$on('filter-service:filter-changed', function ($event, key, value) {
    if ($scope.report) {
      angular.forEach($scope.filters_valid, function (value_filter) {
        if (key === value_filter) {
          $scope.report.filters[value_filter] = value;
        }
      });
    }
  });

  $scope.$on('filter-service:filter-removed', function ($event, key) {
    if ($scope.report) {
      angular.forEach($scope.filters_valid, function (value_filter) {
        if (key === value_filter) {
          delete($scope.report.filters[value_filter]);
        }
      });
    }
  });

  $scope.$on('filters-valid:updated', function ($event, value) {
    $scope.filters_valid = value;
  });

  $scope.$on('validFilters:updated', function ($event, value) {
    $scope.getValidFilters = value;
  });

  $scope.$on('report-type:updated', function ($event, value) {
    $scope.report_type = value;
  });
  
};

app.controller('ReportsActions', ['$scope', '$filter', '$state', '$http', 'ngDialog', 'FilterService', 'PropertyGroupService',
  'AuthDataService', 'ScheduleService', 'NotificationService', 'ReportService', 'ReportFilterService', 'ConfigThemeService', '$q',
  'AccountUserService', 'PermissionService', 'DynamicFormRestService', ReportsActions]);